import { returnTemplate } from '../../../lib/_client';
import { returnStaticProps } from '../../../lib/_helpers';
import Recipes from '../../../templates/recipes';

export default function Template(props) {
  return returnTemplate(props, Recipes);
}

export async function getStaticPaths() {
  return {
    fallback: 'blocking',
    paths: [],
  };
}

export async function getStaticProps(props) {
  const { category, slug } = props.params;
  props.params.slug = `${slug}/${category}`;

  const metaPromise = returnStaticProps({
    ...props,
    params: { slug: 'recipes-meta' },
    type: 'partial',
  });
  const mainPromise = returnStaticProps({
    ...props,
    type: 'recipes',
  });

  const [meta, main] = await Promise.all([metaPromise, mainPromise]);

  meta.props.globals.header.options.inverted = [false];
  main.props.globals = meta.props.globals;

  return main;
}
